import { Unit } from '../components/ServiceItem';

export function getParamsLocation() {
  const urlParams = window.location.search;
  const params: { [index: string]: string } = {};
  urlParams
    .replace('?', '')
    .split('&')
    .map(param => param.split('='))
    .forEach(([key, value]) => {
      params[key] = value;
      return params;
    });
  return params;
}

export function checkQueryParamName(param: string) {
  const params = getParamsLocation();
  if (params) return params[param];
}

export function getUnitIdAndLocalId(unit: Unit) {
  return unit.id_sgh + (unit?.local_id || unit?.locations?.[0]?.name || '');
}
